import { getSession } from '../services/storage-service';

const useBizAccountObjPermissions = (businessId) => {
  const bizAccountObjPermissions = getSession(`${businessId}_biz_Accocunt_user_obj`, true);
  return bizAccountObjPermissions;
};

export default useBizAccountObjPermissions;
